import React, { Component } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import api from "../../utils/Api";
import style from "./ProcedureList.module.css";
import { fetchProcedureList } from "../../redux";
import ttmLodader from "../../assets/images/ttm-loader.gif";

export class ProcedureList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      procedure_id: "",
      isModalOpen: false,
      successMessage: "",
      errorMessage: "",
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      isDataFetched: false,
      proceduresList:[]
    };

    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {
   await this.props.fetchProcedureList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );

    if(this.props.procedureListData && 
      this.props.procedureListData.procedureList && 
      this.props.procedureListData.procedureList.procedure){
      this.setState({ 
        proceduresList: this.props.procedureListData.procedureList.procedure
      })
    }

    setTimeout(() => {
      if (this.props.procedureListData.procedureList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  }

  callProceduresListAPI = async() => {
    this.setState({
      proceduresList: []
    })
    await this.props.fetchProcedureList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );

    if(!this.props.procedureListData.loading){
      this.setState({
        proceduresList: this.props.procedureListData.procedureList.procedure
      })
      setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
      }, 1000);
    }

  }

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callProceduresListAPI();
    });
  };

  onSearchChange = (event) => {
    this.setState({ searchKey: event.target.value, page: 1, isDataFetched: false },()=>{
      this.callProceduresListAPI();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ page, isDataFetched: false },()=>{
      this.callProceduresListAPI();
    });
  };

  toggle = (val) => {
    this.setState((prevState) => ({
      procedure_id: val.procedure_id,
      isModalOpen: !prevState.isModalOpen,
    }));
  };

  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
        <Link title="Edit Procedure" to={{ pathname: `/app/createprocedures/${row.procedure_id}` }}>
          <i className="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
        </Link>
        <Link title="Delete Procedure"
          className="action-icons relatedpartylist-add-icon"
          onClick={() => this.toggle(row)}
        >
          <i className="fa fa-trash"></i>
        </Link>
      </div>
    );
  }

  // Delete API calling
  onDeleteProcedure = async () => {
    try {
      const response = await api.delete("procedure/", {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        },
        data: {
          procedure_id: this.state.procedure_id,
        },
      });
      if (response.status === 200) {
        this.setState({
          successMessage: "Medical procedure deleted successfully!",
        });
        setTimeout(() => {
          this.setState((prevState) => ({
            successMessage: "",
            isModalOpen: !prevState.isModalOpen,
          }));
          this.callProceduresListAPI();
        }, 3000);
      }
    } catch (error) {
      this.setState({
        errorMessage: "Internal server error occurred",
      });
      setTimeout(() => {
        this.setState((prevState) => ({
          errorMessage: "",
        }));
      }, 3000);
    }
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  render() {
    const procedureList = this.props.procedureListData.procedureList;
    return (
      <div className={style.appoListMainWarapper}>
        <div className="row">
          <div className="col-md-4">
            <h3>Medical Procedure </h3>
          </div>
              <div class="col-xl-8 order-3 order-md-2 d-flex flex-wrap  justify-content-start justify-content-md-end RelatedPartiesList_addRoleBtnWrapper__3C9uO">
                <div className="form-group mr-3">
                <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
                
                <Link to="/app/createprocedures">
                  <Button color="primary btn" className={style.addBtn}>
                    <i className="fa fa-plus mr-2"></i>ADD Procedure
                  </Button>
                </Link>       
                   </div>
        </div>
        <BootstrapTable
          bordered={false}
          remote={true}
          data={this.state.proceduresList}
          version="4"
          search={false}
          pagination
          fetchInfo={{
            dataTotalSize: this.props.procedureListData.procedureList.total,
          }}
          options={{
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange,
            onSearchChange: this.onSearchChange,
            sizePerPage: 10,
            page: this.state.page,
            onPageChange: this.onPageChange,
            noDataText: this.setLoader(),
          }}
        >
          <TableHeaderColumn dataField="procedure_name" isKey dataSort={true}>
            Procedure Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="procedure_cost" dataSort={true}>
            Procedure Cost (ZAR)
          </TableHeaderColumn>
          <TableHeaderColumn dataField="procedure_time" dataSort={true}>
            Time Required (Approx.)
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="actions"
            dataFormat={this.actionsFormatter.bind(this)}
            width="10%"
          >
            Actions
          </TableHeaderColumn>
        </BootstrapTable>
        {/* Open a modal for delete procedure */}
        <Modal
          isOpen={this.state.isModalOpen}
          toggle={this.toggle}
          className={style.deleteReason}
          centered
        >
          <ModalHeader toggle={this.toggle} className={style.deleteModalHeader}>
            Delete Medical Procedure
          </ModalHeader>
          <ModalBody>
            <div className={style.deleteReasonHeadingWrapper}>
              <p>
                Please confirm whether you want to delete the entry. If yes,
                then click on delete button
              </p>
            </div>
            <div className={style.deleteReasonFormWrapper}>
              <form onSubmit={this.onSubmit}>
                <div className={style.error}>{this.state.errorField}</div>
                <div className="row">
                  <div className={`col-md-12 ${style.deleteBtnWrapper}`}>
                    <button
                      type="button"
                      className="ttm-primary-btn"
                      onClick={this.onDeleteProcedure}
                    >
                      Delete
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {this.state.successMessage && (
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                    )}
                    {this.state.errorMessage && (
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    procedureListData: state.procedureList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProcedureList: (searchKey, sortBy, page) =>
      dispatch(fetchProcedureList(searchKey, sortBy, page)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcedureList);
